<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p style="text-indent: 0em;">I would like to thank Professor Gideon Lowy for forging the new ideas out of scientific information which lay in isolated university departments. It is fair to say that humanity has produced so much information people were drowning in it whilst searching for wisdom. The forging process included Mike Woods who started as a non-science specialist but ended able to hold his own with the best of them.</p><br/>
<p style="text-indent: 0em;">Zach Bishop became my working partner after he helped to organise the vast amount of information we produced over the years.</p><br/>
<p style="text-indent: 0em;">Nick Lin, and ex-student in Taiwan produced all the illustrations in the book and has helped out endlessly over the years.</p><br/>
<p style="text-indent: 0em;">The book was written in the St Johns Institute of universal truths and a special thanks goes to Kerry and Chris for providing a shoulder to cry on when we were struggling too much. Also, Peter whose breadth of knowledge is so great he is simply known as The Carpet.</p><br/>
<p style="text-indent: 0em;">Tim Hopper for continuing to produce mathematical links which act as foundations.</p><br/>
<p style="text-indent: 0em;">Darren for walks which help to shape ideas into language all can understand, and Emma for just sitting and talking elegantly.</p><br/>
<p style="text-indent: 0em;">Gerald Midgley for helping to kick start the project.</p><br/>
<p style="text-indent: 0em;">Thanks to Aide at the Palace of Reason for serving quite the best ale in the city of Hull.<strong><br/>
</strong></p><br/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?7ded7ed6